import { BRAZE_CODES } from "../utils/constants";
import { AnalyticsOptions } from "./AnalyticsOptions";
import { AnalyticsHandler } from "./IAnalyticsHandler";
var appboy = require("appboy-web-sdk");

export enum AppboyLogTypes {
  PURCHASE = "PURCHASE",
  CUSTOM = "CUSTOM",
}

export class AppBoyOptions extends AnalyticsOptions {
  logType: AppboyLogTypes;

  constructor(logType: AppboyLogTypes, values: any) {
    super(values);
    this.logType = logType;
  }
}

export class AppboyAnalyticsHandler extends AnalyticsHandler {
  constructor() {
    super();

    this.initialize();
  }

  protected initialize(): void {
    const dev = process.env.REACT_APP_ENV === "dev";
    appboy.initialize(dev ? BRAZE_CODES.dev : BRAZE_CODES.prod, {
      enableLogging: dev,
      baseUrl: "https://sdk.fra-01.braze.eu",
    });
    dev && appboy.display.automaticallyShowNewInAppMessages();
  }

  public changeUser(userID: string): void {
    appboy.changeUser(userID);
  }

  public log(
    logEvent: string,
    options: { logType: AppboyLogTypes; values: any[] }
  ): void {
    const appboyOptions = new AppBoyOptions(options.logType, options.values);

    switch (options.logType) {
      case AppboyLogTypes.PURCHASE:
        appboy.logPurchase(logEvent, ...appboyOptions.values);
        break;

      case AppboyLogTypes.CUSTOM:
        appboy.logCustomEvent(logEvent, ...appboyOptions.values);
        break;

      default:
        throw new Error("Invalid Log Type");
    }
  }
}
